module.exports = __webpack_public_path__ + "img/aaron.6f7ecda6.jpg";